import React from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import {
    Container, List, Header, Accordion,
} from 'semantic-ui-react';
import * as OptionsSection from './OptionsSection';

class OptionsTemplate extends React.Component {
    state = { activeIndex: 0 }

    handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex });
    }


    render() {
        const { activeIndex } = this.state;
        const { offers } = this.props;

        if (!offers) {
            console.log('offers missing');
            return null;
        }

        return (
            <div className="options">
                <Container>
                    {offers.map((offer, idx) => (
                        <OptionsSection.Wrapper
                            logo={offer.logo}
                            company={offer.company}
                            link={offer.link}
                            rating={offer.rating}
                            key={`offer${idx.toString()}`}
                        >
                            <OptionsSection.Heading>
                                {offer.mainValueProp}
                            </OptionsSection.Heading>
                            <OptionsSection.Body>
                                <List bulleted>
                                    {offer.benefits.map((benefit, benefitIdx) => (
                                        <List.Item key={`benefit${benefitIdx.toString()}`}>
                                            {benefit.link ? (
                                                <strong>
                                                    <a
                                                        href={offer.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer sponsored"
                                                    >
                                                        {benefit.item}
                                                    </a>
                                                </strong>
                                            ) : benefit.item}
                                        </List.Item>
                                    ))}
                                </List>
                            </OptionsSection.Body>
                            <OptionsSection.Details>
                                <div className="options--details">
                                    {offer.details.map((detail, detailIdx) => (
                                        <div className="options--details-container" key={`detail${detailIdx.toString()}`}>
                                            <Header size="small" className="options--details__header">
                                                {detail.header}
                                            </Header>
                                            <div className="options--details__content">
                                                {detail.additional ? (
                                                    <Accordion>
                                                        <Accordion.Title
                                                            active={activeIndex === idx.toString()}
                                                            index={idx.toString()}
                                                            onClick={this.handleClick}
                                                        >
                                                            {detail.content}
                                                        </Accordion.Title>
                                                        <Accordion.Content active={activeIndex === idx.toString()}>
                                                            {detail.additional}
                                                        </Accordion.Content>
                                                    </Accordion>
                                                ) : detail.content }
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </OptionsSection.Details>
                            <OptionsSection.Review>
                                {offer.review.map((item, paragraphIdx) => (
                                    <p key={`paragraph${paragraphIdx.toString()}`}>
                                        {item}
                                    </p>
                                ))}
                            </OptionsSection.Review>
                            <OptionsSection.Additional>
                                <List bulleted>
                                    {offer.benefits.map((benefit, benefitIdx) => (
                                        <List.Item key={`benefit${benefitIdx.toString()}`}>
                                            {benefit.link ? (
                                                <strong>
                                                    <a
                                                        href={offer.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer sponsored"
                                                    >
                                                        {benefit.item}
                                                    </a>
                                                </strong>
                                            ) : benefit.item}
                                        </List.Item>
                                    ))}
                                </List>
                            </OptionsSection.Additional>
                        </OptionsSection.Wrapper>
                    ))}
                </Container>
            </div>
        );
    }
}

OptionsTemplate.propTypes = {
    // eslint-disable-next-line react/require-default-props
    offers: PropTypes.arrayOf(PropTypes.shape({
        logo: PropTypes.string.isRequired,
        company: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        rating: PropTypes.number.isRequired,
        details: PropTypes.arrayOf(PropTypes.shape({
            header: PropTypes.string.isRequired,
            content: PropTypes.string.isRequired,
        })),
        mainValueProp: PropTypes.string.isRequired,
        benefits: PropTypes.arrayOf(PropTypes.shape({
            item: PropTypes.string.isRequired,
            link: PropTypes.bool,
        })),
        review: arrayOf(PropTypes.string.isRequired),
    })),
};

OptionsTemplate.defaultProps = {
    offers: { benefits: { link: true } },
};


export default OptionsTemplate;
